<template>
  <div class="nav-wrapper" :class="{ 'is-sticky': isSticky }">
    <div class="container">
      <nav
        ref="nav"
        class="nav"
        role="navigation"
        :class="{ 'mobile-menu-overlay': mobileMenuIsOpen }"
        aria-label="main navigation"
        tabindex="-1"
      >
        <div class="nav-left">
          <a id="logo" ref="menuLogo" class="hp__redistricting_nav_logo nav-item nav-item--logo" href="https://www.aclu.org/" title="ACLU.org" alt="ACLU.org">
            <svg width="105" height="37" viewBox="0 0 131 47" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M57.0207 27.2747V30.6145C57.0207 33.3976 56.0448 34.65 53.2565 34.65H51.8623C49.074 34.65 48.0981 33.2584 48.0981 30.6145V15.5855C48.0981 12.8024 49.074 11.55 51.8623 11.55H53.2565C56.0448 11.55 57.0207 12.9416 57.0207 15.5855V18.9253H68.3133V27.2747H57.0207ZM15.1962 27.6922L18.5422 9.32349H19.3787L22.7246 27.6922H15.1962ZM-1.32956e-07 45.2259H11.9897L13.3838 37.4331H24.6764L26.0706 45.2259H38.4785L36.9449 37.8506H37.5026C39.4544 43.2777 43.9157 46.2 51.4441 46.2H52.8382C62.7367 46.2 67.6162 41.0512 67.895 32.2843H68.5921V45.2259H97.451V37.1548H97.8692C100.1 43.2777 104.84 46.2 112.368 46.2H114.041C124.637 46.2 130.213 40.7729 130.213 30.3361V0.974096H117.527V30.8928C117.527 33.3976 116.551 34.7892 113.902 34.7892H112.508C109.719 34.7892 108.883 33.3976 108.883 30.8928V0.974096H96.1962V33.2584H81V0.974096H68.3133V13.9157H67.6162C67.6162 5.42711 63.1549 1.3271e-07 53.117 1.3271e-07H51.1652C40.2909 1.3271e-07 35.4114 5.56627 35.4114 15.5855V30.4753C35.4114 31.0319 35.4114 31.5886 35.4114 32.1452H34.9931L29.2771 0.974096H9.20138L-1.32956e-07 45.2259Z" transform="translate(0.142578 0.399902)" fill="#ffffff"></path>
            </svg>
          </a>
        </div>
        <div class="nav-right">
          <div v-show="!isMobile || mobileMenuIsOpen" class="nav-right__links">
            <a
              class="hp__redistricting_nav_101 nav-item"
              :class="{ 'nav-item--current': currentPage === '101' && !mobileMenuIsOpen }"
              href="https://www.aclu.org/redistricting/redistricting-101"
            >
              Redistricting 101
            </a>
            <a
              class="hp__redistricting_nav_cases nav-item"
              :class="{ 'nav-item--current': currentPage === 'cases' && !mobileMenuIsOpen }"
              href="https://www.aclu.org/redistricting/cases"
            >
              Redistricting Cases
            </a>
            <a
              class="hp__redistricting_nav_district_time_machine nav-item"
              :class="{ 'nav-item--current': currentPage === 'district-time-machine' && !mobileMenuIsOpen }"
              href="/"
            >
              District Time Machine
            </a>
          </div>

          <div v-show="isMobile">
            <a
              v-if="!mobileMenuIsOpen"
              ref="menu"
              class="hp__redistricting_nav_menu nav-item nav-item--mobile"
              href="#"
              @click.prevent="openMobileMenu"
            >
              Menu
            </a>
            <a
              v-else
              ref="close"
              role="button"
              href="#"
              class="hp__redistricting_nav_menu_close close-x"
              @click.prevent="closeMobileMenu"
            >
              <span class="screenReaderOnly">Close menu</span>
            </a>
          </div>

          <div v-show="!mobileMenuIsOpen" class="nav-item donate-wrapper">
            <a
              role="button"
              href="https://action.aclu.org/give/donate-for-fair-maps"
              class="hp__redistricting_nav_donate button"
            >
              Donate
            </a>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: String,
      default: 'district-time-machine',
    },
    isSticky: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      mobileMenuIsOpen: false,
      savedPageYOffset: null,
    }
  },
  watch: {
    mobileMenuIsOpen() {
      if (this.mobileMenuIsOpen) {
        // prevent background scrolling
        this.lockBodyScroll()
        this.$refs.menuLogo.focus()
        document.addEventListener('focusin', this.trapFocusInsideOfModal)
      } else {
        // allow background scrolling
        this.retrieveBodyScroll()
        document.removeEventListener('focusin', this.trapFocusInsideOfModal)
      }
    },
  },
  methods: {
    // prevents keyboard focus from falling outside of modal
    trapFocusInsideOfModal(event) {
      const navModal = this.$refs.nav
      if (!navModal.contains(event.target)) {
        event.stopPropagation()
        this.$refs.menuLogo.focus()
      }
    },
    lockBodyScroll() {
      this.savedPageYOffset = window.pageYOffset
      document.body.style.overflowY = 'hidden'
      document.body.style.height = '100vh'
      document.body.style.touchAction = 'none'
    },
    retrieveBodyScroll() {
      document.body.style.overflowY = 'visible'
      document.body.style.height = 'auto'
      document.body.style.touchAction = 'auto'
      window.scrollTo({ top: this.savedPageYOffset, left: 0, behavior: 'instant' })
    },
    openMobileMenu() {
      this.mobileMenuIsOpen = true
    },
    closeMobileMenu() {
      this.mobileMenuIsOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';
.container {
  padding: 0 15px;
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
  max-width: 1140px;
}
.nav-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: $offblack;
  z-index: 1001;
  font-size: 18px;
}
.is-sticky {
  position: fixed;
  top: 0;
  width: 100%;
  height: auto;
  z-index: 19999;
}
.nav,
.nav-left,
.nav-right,
.nav-right__links {
  display: flex;
  flex-direction: row;
}
.nav {
  justify-content: space-between;
  background-color: $offblack;
  .nav-left,
  .nav-right {
    align-items: center;
  }
  .nav-right__links {
    height: 100%;
  }
  .nav-item {
    text-decoration: none;
    @include font-family-standard-bold;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
    align-items: center;
    position: relative;
    color: #FFF;
    height: 100%;
    padding: 0 15px 0 15px;
    margin-right: 30px;

    &:hover {
      opacity: .8;
    }
    &--logo {
      padding: 0;
      margin: 0;
    }
    &--current {
      &:after {
        content: '';
        border-bottom: 5px solid $light-green;
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;
      }
    }
  }
}
.mq-mobile .nav .nav-item {
  height: auto;
  padding: 15px 0 15px 0;
  &--logo {
    padding: 0;
    margin: 0;
  }
}
.button {
  text-decoration: none;
  @include font-family-standard-bold;
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border-radius: 0;
  box-shadow: none;
  display: inline-flex;
  font-size: 18px;
  height: 33px;
  min-width: 45px;
  width: auto;
  line-height: 1.5;
  padding: 5px;
  position: relative;
  vertical-align: top;

  border: none;
  background-color: $light-green;
  color: $offblack;
  padding-left:30px;
  padding-right:30px;
  border-radius: 3px !important;
}
.nav .donate-wrapper {
   padding-top: 10px;
   padding-bottom: 10px;
   margin: 0;
}

.nav .nav-item--mobile {
  padding: 15px 0;
  margin-left: 15px;
  margin-right: 15px;
}

.mq-mobile #logo {
  margin-top: 6px;
}

// Mobile menu overlay
.mobile-menu-overlay {
  position: fixed;
  z-index: 20000;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overscroll-behavior: contain;
  left: 0px;
  padding: 15px;
  &.nav {
    flex-direction: column;
    justify-content: flex-start;
  }
  .nav-left,
  .nav-right,
  .nav-right__links {
    flex-direction: column;
    align-items: flex-start;
  }
  .nav-left {
    margin-bottom: 30px;
  }
}
// Close button
$closeHeight: 21px;
.close-x {
  position: absolute;
  top: 5px;
  right: 30px;
  padding-top: $closeHeight;
  height: 100%;
  width: calc(100vw - 160px); // hit box covers all but the logo
}
.close-x:before,
.close-x:after {
  position: absolute;
  right: $closeHeight/2 + $closeHeight;
  content: ' ';
  height: $closeHeight;
  width: 3px;
  background-color: $light;
}
.close-x:before {
  transform: rotate(45deg);
}
.close-x:after {
  transform: rotate(-45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue